module.exports = __webpack_public_path__ + "img/img35.b17ba964.jpg";